module.exports = __webpack_public_path__ + "img/logo.5be9dfb1.png";